import React, { useState, ChangeEvent, FormEvent } from 'react';
import { instance } from '../../api/axiosInstance';
interface Article {
    id: number;
    title: string;
    content: string;
    imgURL?: string;
    url?: string;
}
interface ArticleModalProps {
    article: Article;
    onClose: () => void;
    onArticleUpdated: () => void;
}

const ArticleModal: React.FC<ArticleModalProps> = ({ article, onClose, onArticleUpdated }) => {
    const [formData, setFormData] = useState<Article>(article);

    const handleChange = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = event.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async (event: FormEvent) => {
        event.preventDefault();
        await instance.put(`/api/articles/${article.id}`, formData);
        onArticleUpdated();
        onClose();
    };

    return (
        <div>
            <form onSubmit={handleSubmit}>
                <input
                    type="text"
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                />
                <textarea
                    name="content"
                    value={formData.content}
                    onChange={handleChange}
                />
                <input
                    type="text"
                    name="url"
                    value={formData.url}
                    onChange={handleChange}
                />
                <button type="submit">Update Article</button>
            </form>
            <button onClick={onClose}>Close</button>
        </div>
    );
};

export default ArticleModal;